import React, { useState, useCallback, useEffect } from 'react';
import { TextField, Button, CircularProgress } from '@material-ui/core';
import { initial, RemoteData, pending, success, failure } from '@devexperts/remote-data-ts';
import { AjaxError, ajax } from 'rxjs/ajax';
import { refreshJwt, getOptions, getUrl } from 'sideEffect/services';

interface TestCalcProps {
    entityType: string;
    entityId: string;
}
const TestCalc: React.SFC<TestCalcProps> = props => {
    const [text, setText] = useState('');
    const [state, setState] = useState<RemoteData<AjaxError, any>>(initial);

    const submit = useCallback(() => {
        setState(pending);
    }, []);
    useEffect(() => {
        if (state.isPending()) {
            const $ajax = refreshJwt(
                ajax({
                    ...getOptions(getUrl('api/test-calc'), 'POST', {
                        entityType: props.entityType,
                        entityId: props.entityId,
                        calcExpression: text,
                    }),
                    responseType: 'text',
                }),
            );

            const subscription = $ajax.subscribe(
                res => {
                    setState(success(res.response));
                },
                (error: AjaxError) => {
                    setState(failure(error));
                },
            );
            return () => {
                if (!subscription.closed) {
                    subscription.unsubscribe();
                }
            };
        }
    }, [state, setState, props.entityId, props.entityType, text]);
    return (
        <div style={{ padding: '1em' }}>
            Backend Calcs can be tested below. A different set of functions will be available.
            <br />
            <TextField
                multiline={true}
                rows={2}
                margin="normal"
                style={{ width: '100%' }}
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={e => setText(e.target.value)}
                onBlur={e => setText(e.target.value)}
                value={text}
                label="Calc Expression"
            />
            <Button variant="contained" color="primary" onClick={submit}>
                Submit
            </Button>
            {state.fold(
                null,
                <CircularProgress />,
                error => (
                    <div>
                        Failed:{' '}
                        {error.message === 'ajax error' ? 'Network error' : JSON.stringify(error.response, null, 2)}
                    </div>
                ),
                success => (
                    <div>Success: {success}</div>
                ),
            )}
        </div>
    );
};

export default TestCalc;
